import { COMPANY_NAME } from '../../components/SidebarNew/userHub';
import type { RawNode } from './orgTree';

const img = (id: string) => `https://images.unsplash.com/photo-${id}?w=100`;
const emp = (id: string, name: string, role: string, avatar: string, children?: RawNode[]): RawNode => ({ id, type: 'employee', name, role, avatar: img(avatar), children });
const dept = (id: string, label: string, children: RawNode[], badgeColor = 'bg-amber-500'): RawNode => ({ id, type: 'department', label, badgeColor, children });

// Dữ liệu mẫu: Công ty → Ban lãnh đạo → Phòng ban → Trưởng phòng → Lead → Nhân viên
export const seedOrg: RawNode = {
  id: 'root-company',
  type: 'department',
  kind: 'company',
  label: COMPANY_NAME,
  badgeColor: 'bg-amber-500',
  children: [
    {
      id: 'root-bgd',
      type: 'department',
      kind: 'board',
      label: 'Ban lãnh đạo',
      badgeColor: 'bg-amber-500',
      children: [
        emp('emp-pvh-1', 'Hoàng Văn Tuyền', 'Tổng Giám đốc', '1507003211169-0a1dd7228f2d'),
        dept('kd-3', 'Phòng Kinh Doanh 3', [
          emp('emp-hn3-1', 'Nguyễn Văn Nam', 'Trưởng phòng KD 3', '1534528741775-53994a69daeb'),
        ], 'bg-emerald-500'),
        dept('phong-ba', 'Phòng BA', [
          emp('emp-ba-1', '[Win Auto] Hải Cao', 'Giám đốc Marketing', '1507003211169-0a1dd7228f2d', [
            emp('emp-ba-2', 'Lưu Đức Bảo', 'Lead marketing', '1500648767791-00dcc994a43e', [
              emp('emp-ba-3', 'Phạm Ngọc Đăng Khoa', 'Nhân viên marketing', '1472099645785-5658abf4ff4e'),
            ]),
          ]),
        ]),
        dept('phap-che', 'Phòng Pháp Chế', [
          emp('emp-pc-1', 'Phạm Đăng Khoa', 'Trưởng phòng pháp chế', '1507003211169-0a1dd7228f2d', [
            emp('emp-pc-2', 'Trần Thu Vân', 'Lead pháp chế', '1494790108377-be9c29b29330', [
              emp('emp-pc-3', 'Lê Hoàng Nam', 'Chuyên viên pháp chế', '1500648767791-00dcc994a43e'),
              emp('emp-pc-4', 'Nguyễn Thị Mai', 'Nhân viên hồ sơ', '1438761681033-6461ffad8d80'),
              emp('emp-pc-5', 'Vũ Minh Tuấn', 'Tập sự pháp chế', '1472099645785-5658abf4ff4e'),
            ]),
          ]),
        ]),
        dept('hr-1office', 'Hành Chính Nhân Sự', [
          emp('emp-hr-1', 'Nguyễn Diệp', 'Trưởng phòng HCNS', '1573496359142-b8d87734a5a2', [
            emp('emp-hr-2', 'Lê Việt Thắng', 'Lead C&B', '1560250097-0b93528c311a', [
              emp('emp-hr-3', 'Bàn Dầu An', 'Chuyên viên tuyển dụng', '1519085360753-af0119f7cbe7'),
              emp('emp-hr-4', 'Phan Đình Nguyên', 'Chuyên viên đào tạo', '1500648767791-00dcc994a43e'),
              emp('emp-hr-5', 'Trần Mỹ Duyên', 'Nhân viên hành chính', '1580489944761-15a19d654956'),
            ]),
          ]),
        ]),
        dept('kd-5', 'Phòng Kinh Doanh 5', [
          emp('emp-kd5-1', 'Vũ Đức A12', 'Trưởng phòng kinh doanh', '1507003211169-0a1dd7228f2d', [
            emp('emp-kd5-2', 'Nguyễn Hiền', 'Lead kinh doanh', '1534528741775-53994a69daeb', [
              emp('emp-kd5-3', 'Trần Văn Mạnh', 'Nhân viên kinh doanh', '1500648767791-00dcc994a43e'),
            ]),
          ]),
        ]),
        dept('pvh-marketing', 'PVH - PHÒNG MARKETING', [
          emp('emp-pvh-2', 'Đặng Quốc Huy', 'Content Creator', '1500648767791-00dcc994a43e'),
        ], 'bg-blue-500'),
      ],
    },
  ],
};

/** Các nút mở sẵn khi vào trang: mọi phòng ban và các cấp quản lý có cấp dưới */
export const SEED_EXPANDED = [
  'root-company', 'root-bgd', 'phong-ba', 'phap-che', 'hr-1office', 'kd-5', 'kd-3', 'pvh-marketing',
  'emp-ba-1', 'emp-ba-2', 'emp-pc-1', 'emp-pc-2', 'emp-hr-1', 'emp-hr-2', 'emp-kd5-1', 'emp-kd5-2',
];
